import {Component, Input} from '@angular/core';
import {ProfileModel} from '../../../../../../models/profile.model';
import moment from 'moment/moment';

@Component({
  selector: 'app-chart-base',
  templateUrl: './chart-base.component.html',
  styleUrls: ['./chart-base.component.css']
})
export class ChartBaseComponent {
  @Input() memberId: number;
  @Input() groupId: number;
  @Input() userRole: number;
  @Input() isAdult: boolean;
  @Input() profile: ProfileModel;
  @Input() chartName: string;
  onDateChange(data: {
    fromDate: string,
    toDate: string,
  }) {
    // This part will be implemented in child component
  }

  onPrint(complete:() => void) {
    // This part will be implemented in child component
  }

  getUserName(profile) {
    const nameList = [];
    if (profile?.firstName) {
      nameList.push(profile?.firstName);
    }
    if (profile?.lastName) {
      nameList.push(profile?.lastName);
    }
    return nameList.join(' ');
  }

  getPageTitle({profile, fromDate, toDate, chartName}) {
    try {
      return `${profile?.firstName}_${profile.lastName}_${moment(fromDate).format('MMDDYYYY')}_to_${moment(toDate).format('MMDDYYYY')} Progress Graph: ${chartName}`;
    } catch (e) {
      console.error(e);
    }
    return null;
  }
}
